import {useTheme} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import * as CONSTANTS from "../common/constant";

export const useBreakpoints = () => {
    const theme = useTheme();

    const extraSmallScreen = useMediaQuery(theme.breakpoints.up("xs"), { noSsr: true });
    const smallScreen = useMediaQuery(theme.breakpoints.up("sm"), { noSsr: true });
    const mediumScreen = useMediaQuery(theme.breakpoints.up("md"), { noSsr: true });
    const largeScreen = useMediaQuery(theme.breakpoints.up("lg"), { noSsr: true });
    const extraLargeScreen = useMediaQuery(theme.breakpoints.up("xl"), { noSsr: true });

    const verticalSmall = useMediaQuery(CONSTANTS.BREAKPOINT_VERTICAL_SM);

    const isExtraSmallScreen = () => {
        return extraSmallScreen && !smallScreen && !mediumScreen && !largeScreen && !extraLargeScreen;
    };

    const isSmallScreen = () => {
        return (smallScreen || verticalSmall) && !mediumScreen && !largeScreen && !extraLargeScreen;
    };

    const isMediumScreen = () => {
        return mediumScreen && !largeScreen && !extraLargeScreen;
    };

    const isLargeScreen = () => {
        return largeScreen && !extraLargeScreen;
    };

    const isExtraLargeScreen = () => {
        return extraLargeScreen;
    };

    const isSmallScreenVertical = () => {
        return verticalSmall;
    };

    const getBreakpoint = () => {
        let result;
        if (isExtraLargeScreen()) {
            result = CONSTANTS.BREAKPOINT_XL;
        }
        else if (isLargeScreen()) {
            result = CONSTANTS.BREAKPOINT_LG;
        }
        else if (isMediumScreen()) {
            result = CONSTANTS.BREAKPOINT_MD;
        }
        else if (isSmallScreen()) {
            result = CONSTANTS.BREAKPOINT_SM;
        }
        else {
            result = CONSTANTS.BREAKPOINT_XS;
        }

        return result;
    };

    return {
        isExtraSmallScreen,
        isSmallScreen,
        isMediumScreen,
        isLargeScreen,
        isExtraLargeScreen,
        isSmallScreenVertical,
        getBreakpoint
    };
};
